import {
    COMPRAS_LIST,
    COMPRAS_FULLLIST,
    COMPRAS_LISTA,
    COMPRAS_FILTER,
    COMPRAS_CREATE,
    COMPRAS_CREATE_FORM,
    COMPRAS_CREATE_SUCCESS,
    COMPRAS_CREATE_FORM_SUCCESS,
    COMPRAS_LIST_SUCCESS,
    COMPRAS_FULLLIST_SUCCESS,
    COMPRAS_REQUEST_FAILED,
    COMPRAS_UPDATE,
    COMPRAS_UPDATE_SUCCESS,
    COMPRAS_READ,
    COMPRAS_READ_SUCCESS,
  } from "./actionTypes";
  
  const initialState = {
    compras: [],
    comprasCreated: {},
    comprasUpdated: {},
    loading: false,
    error: "",
  };
  
  const compras = (state = initialState, action) => {
    switch (action.type) {
      case COMPRAS_CREATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case COMPRAS_CREATE_FORM:
        state = {
          ...state,
          loading: true,
        };
        break;
      case COMPRAS_LIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case COMPRAS_FULLLIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case COMPRAS_LISTA:
        state = {
          ...state,
          loading: true,
        };
        break;
      case COMPRAS_FILTER:
        state = {
          ...state,
          loading: true,
        };
        break;
        case COMPRAS_READ:
          state = {
            ...state,
            loading: true,
          };
          break;
        case COMPRAS_CREATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          comprasCreated: action.payload,
          error: "",
        };
        break;
        case COMPRAS_CREATE_FORM_SUCCESS:
        state = {
          ...state,
          loading: false,
          comprasCreated: action.payload,
          error: "",
        };
        break;
      case COMPRAS_UPDATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case COMPRAS_READ_SUCCESS:
        state = {
          ...state,
          loading: false,
          compras: action.payload,
          error: "",
        };
        break;
      case COMPRAS_LIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          compras: action.payload,
          comprasCreated: {},
          comprasUpdated: {},
          error: "",
        };
        break;
      case COMPRAS_FULLLIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          compras: action.payload,
          comprasCreated: {},
          comprasUpdated: {},
          error: "",
        };
        break;
      case COMPRAS_UPDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          comprasUpdated: action.payload,
          error: "",
        };
        break;
      case COMPRAS_REQUEST_FAILED:
        state = {
          ...state,
          loading: false,
          error: action.payload,
        };
        break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default compras;
  